export function UswdsIdentifier() {
  return (
    <div className="usa-identifier">
      <section className="usa-identifier__section usa-identifier__section--masthead" aria-label="Agency identifier,">
        <div className="usa-identifier__container">
          <div className="usa-identifier__logos">
            <a href="https://www.blm.gov" className="usa-identifier__logo">
              <img className="usa-identifier__logo-img" src="/images/BLM_Logo.png" alt="BLM logo" />
            </a>
          </div>
          <section className="usa-identifier__identity" aria-label="Agency description,">
            <p className="usa-identifier__identity-domain">whbstewardship.blm.gov</p>
            <p className="usa-identifier__identity-disclaimer">
              An official website of the <a href="https://www.blm.gov">Bureau of Land Management</a>
            </p>
          </section>
        </div>
      </section>
      <nav className="usa-identifier__section usa-identifier__section--required-links" aria-label="Important links,">
        <div className="usa-identifier__container">
          <ul className="usa-identifier__required-links-list">
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.blm.gov/about">About BLM</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.doi.gov/accessibility">Accessibility statement</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.blm.gov/about/foia">FOIA requests</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.doi.gov/pmb/eeo/reports-repository">No FEAR Act data</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.doioig.gov">Office of the Inspector General</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.doi.gov/bpp">Performance reports</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.doi.gov/pfm/afr">Agency financial reports</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.doi.gov/disclaimer">Disclaimer</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.doi.gov/privacy">Privacy policy</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.blm.gov/info/notices/vulnerability-disclosure">Vulnerability disclosure policy</a>
            </li>
            <li className="usa-identifier__required-links-item">
              <a className="usa-identifier__required-link usa-link" href="https://www.doi.gov/cummings-act-notices">Cummings Act notices</a>
            </li>
          </ul>
        </div>
      </nav>
      <section className="usa-identifier__section usa-identifier__section--usagov" aria-label="U.S. government information and services,">
        <div className="usa-identifier__container">
          <div className="usa-identifier__usagov-description">
            Looking for U.S. government information and services?
          </div>
          {' '}<a href="https://www.usa.gov" className="usa-link">Visit USA.gov</a>
        </div>
      </section>
    </div>
  );
}